<div class="flex shrink-0 flex-col min-h-0 items-center justify-[safe_center] gap-6 pt-6 pb-10">
    <!-- Header Section -->
    <div class="my-4 flex w-full max-w-[90rem] items-center justify-between gap-3 px-6">
        <div class="text-5xl font-extrabold text-[var(--p-warm-gray-50)]">SESAMMTOOL 3</div>
        <div class="flex items-center gap-4 text-2xl font-bold text-[var(--p-warm-gray-50)]">
            Model and visualize SESAMM
        </div>
    </div>

    <div class="flex w-full max-w-[90rem] flex-col gap-6 px-6">
        <!-- My Favorites -->
        <p-card class="w-full rounded-lg!">
            <div class="flex flex-col gap-3">
                <div class="flex items-center justify-between gap-2">
                    <div class="flex items-center gap-2">
                        <span class="font-bold leading-none">MY FAVORITES</span>
                        <i
                            class="pi pi-question-circle inline-flex h-4 w-4 cursor-help items-center justify-center leading-none text-[var(--p-text-muted-color)]"
                            pTooltip="Right click on the favorite items to change color or remove"
                            tooltipPosition="right"
                            tabindex="0"
                            role="img"
                            aria-label="Favorite item help"
                        ></i>
                    </div>
                    @if (favorites$ | async; as favorites) {
                        <p-button
                            icon="pi pi-ellipsis-v"
                            size="small"
                            variant="text"
                            pTooltip="Favorite options"
                            aria-label="Favorite options"
                            [disabled]="favorites.length === 0"
                            (onClick)="favoriteMenu.toggle($event)"
                        ></p-button>
                    }
                </div>
                @if (favoritesLoading$ | async) {
                    <p-progress-spinner
                        ariaLabel="Loading favorites"
                        [style]="{
                            width: '2rem',
                            height: '2rem',
                            margin: '0',
                            '--p-progressspinner-color-one': 'var(--p-primary-600)',
                        }"
                        strokeWidth="6"
                    />
                } @else if (favorites$ | async; as favorites) {
                    @if (favorites.length) {
                        <div class="flex flex-wrap gap-2">
                            @for (favorite of favorites; track favorite.route) {
                                <div
                                    class="favorite-item flex items-center"
                                    (contextmenu)="
                                        selectFavoriteForContextMenu(favorite);
                                        favoriteContextMenu.show($event);
                                        $event.preventDefault()
                                    "
                                    [style.--favorite-color]="getFavoriteColor(favorite)"
                                    [style.background-color]="getFavoriteColor(favorite)"
                                >
                                    <a
                                        pButton
                                        [routerLink]="getFavoriteUrl(favorite)"
                                        size="small"
                                        [outlined]="true"
                                        class="favorite-item-button"
                                    >
                                        <i
                                            pButtonIcon
                                            class="pi pi-star-fill"
                                            aria-hidden="true"
                                        ></i>
                                        <span pButtonLabel>{{ favorite.label }}</span>
                                    </a>
                                </div>
                            }
                        </div>
                    } @else {
                        <span class="text-[var(--p-text-muted-color)]">
                            Favorite pages will appear here. Use the star icon on any page to add to
                            favorites.
                        </span>
                    }
                }
            </div>
        </p-card>

        <!-- User Support Shortcuts -->
        <div
            class="grid w-full grid-cols-[repeat(auto-fit,minmax(min(315px,100%),1fr))] place-items-center justify-center gap-6"
        >
            <p-card class="home-link-card-shell">
                <div
                    class="flex h-full flex-col gap-6 px-4 py-3 text-sm max-md:min-h-[17rem] max-md:p-5"
                >
                    <div class="flex items-center gap-7 max-md:flex-col max-md:text-center">
                        <span class="home-link-card-icon">
                            <i class="pi pi-book text-[2rem]"></i>
                        </span>
                        <div class="flex min-w-0 flex-col gap-[0.35rem]">
                            <span class="text-[1.15rem] font-bold">Wiki</span>
                            <span class="font-medium">SesammTool 3</span>
                        </div>
                    </div>
                    <a
                        class="mt-auto flex w-full justify-center"
                        href="https://scaniaazureservices.sharepoint.com/sites/EU_SE_RD_CF0095/SitePages/SesammTool-3.aspx"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <p-button
                            label="Open Wiki"
                            icon="pi pi-external-link"
                            size="small"
                            styleClass="w-[22rem] h-[2.5rem] justify-center"
                        ></p-button>
                    </a>
                </div>
            </p-card>

            <p-card class="home-link-card-shell">
                <div
                    class="flex h-full flex-col gap-3 px-4 py-3 text-sm max-md:min-h-[17rem] max-md:p-5"
                >
                    <div class="flex items-center gap-7 max-md:flex-col max-md:text-center">
                        <span class="home-link-card-icon">
                            <i class="pi pi-question text-[2rem]"></i>
                        </span>
                        <div class="flex min-w-0 flex-col gap-[0.35rem]">
                            <span class="text-[1.15rem] font-bold">Help Pages / FAQ</span>
                            <span class="font-medium">Frequently Asked Questions</span>
                        </div>
                    </div>
                    <span class="text-[0.85rem] leading-[1.35]">
                        <strong>To get access to Help pages or FAQ</strong>, visit
                        <a
                            class="font-semibold text-[var(--p-primary-color)] underline underline-offset-[0.15rem]"
                            href="https://welcome.collaborationlayer-traton.com/welcome"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Our Services-page
                            <i class="pi pi-external-link" style="font-size: 0.7rem"></i>
                        </a>
                        and search for SesammTool 3, then choose "SesammTool 3 - Help pages."
                    </span>
                    <div class="mt-auto flex flex-wrap justify-center gap-2">
                        <a
                            href="https://confluence.collaborationlayer-traton.com/spaces/SesammTool/overview"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <p-button
                                label="Help Pages"
                                icon="pi pi-external-link"
                                size="small"
                                styleClass="w-[22rem] h-[2.5rem] justify-center"
                            ></p-button>
                        </a>
                    </div>
                </div>
            </p-card>

            <p-card class="home-link-card-shell">
                <div
                    class="flex h-full flex-col gap-6 px-4 py-3 text-sm max-md:min-h-[17rem] max-md:p-5"
                >
                    <div class="flex items-center gap-7 max-md:flex-col max-md:text-center">
                        <span class="home-link-card-icon">
                            <i class="pi pi-headphones text-[2rem]"></i>
                        </span>
                        <div class="flex min-w-0 flex-col gap-[0.35rem]">
                            <span class="text-[1.15rem] font-bold">Support & Feedback</span>
                            <span class="font-medium">Support Channel</span>
                        </div>
                    </div>
                    <a
                        class="mt-auto flex w-full justify-center"
                        href="https://teams.microsoft.com/l/channel/19%3A0b7674988f2a41d09e4a34bd94f3b5ec%40thread.skype/Support%20and%20Feedback?groupId=b20c0fb0-2b11-4f41-a78a-c60fa8d141af&tenantId=3bc062e4-ac9d-4c17-b4dd-3aad637ff1ac"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <p-button
                            label="Open Support & Feedback"
                            icon="pi pi-external-link"
                            size="small"
                            styleClass="w-[22rem] h-[2.5rem] justify-center"
                        ></p-button>
                    </a>
                </div>
            </p-card>
        </div>

        <!-- Release Notes -->
        <p-card class="w-full rounded-lg!">
            <div class="flex flex-col gap-3">
                <div class="flex flex-wrap items-center justify-between gap-3">
                    <span class="font-bold">RELEASE NOTES</span>
                    <p-button
                        label="Show all"
                        icon="pi pi-list"
                        size="small"
                        variant="text"
                        (onClick)="openAllReleaseNotesDialog()"
                    ></p-button>
                </div>
                <p-accordion class="release-months-accordion" [value]="releaseMonths[0].month">
                    @for (group of releaseMonths; track group.month) {
                        <p-accordion-panel [value]="group.month">
                            <p-accordion-header>{{ group.month }}</p-accordion-header>
                            <p-accordion-content>
                                <p-accordion
                                    [value]="getReleaseNoteDialogPanelValue(group.notes[0], group)"
                                >
                                    @for (note of group.notes; track note.version) {
                                        <p-accordion-panel
                                            [value]="getReleaseNoteDialogPanelValue(note, group)"
                                        >
                                            <p-accordion-header>
                                                <span class="flex flex-wrap items-center gap-2">
                                                    <span class="font-semibold"
                                                        >Version {{ note.version }}</span
                                                    >
                                                    <span
                                                        class="font-normal text-[var(--p-text-muted-color)]"
                                                    >
                                                        {{ note.date }}
                                                    </span>
                                                </span>
                                            </p-accordion-header>
                                            <p-accordion-content>
                                                <ul class="list-disc pl-5">
                                                    @for (
                                                        change of getReleaseNotePreview(note);
                                                        track $index
                                                    ) {
                                                        <li>{{ change }}</li>
                                                    }
                                                </ul>
                                                @if (hasHiddenReleaseNoteChanges(note)) {
                                                    <button
                                                        type="button"
                                                        class="mt-1 block w-fit cursor-pointer border-0 bg-transparent p-0 text-sm font-semibold text-[var(--p-primary-color)] underline underline-offset-[0.15rem]"
                                                        (click)="
                                                            openReleaseNotesDialog(note, group)
                                                        "
                                                    >
                                                        ... show
                                                        {{ getHiddenReleaseNoteChangeLabel(note) }}
                                                    </button>
                                                }
                                            </p-accordion-content>
                                        </p-accordion-panel>
                                    }
                                </p-accordion>
                            </p-accordion-content>
                        </p-accordion-panel>
                    }
                </p-accordion>
            </div>
        </p-card>
    </div>
</div>

<p-dialog
    header="Release Notes"
    [(visible)]="isReleaseNotesDialogVisible"
    [modal]="true"
    appendTo="body"
    [style]="{ width: '95vw', 'max-width': '64rem' }"
>
    <div class="flex max-h-[70vh] flex-col gap-4 overflow-y-auto pr-1">
        @for (group of releaseMonths; track group.month) {
            <section class="flex flex-col gap-2">
                <h3 class="text-base font-semibold">{{ group.month }}</h3>
                <p-accordion [value]="releaseNotesDialogNoteValue">
                    @for (note of group.notes; track note.version) {
                        <p-accordion-panel [value]="getReleaseNoteDialogPanelValue(note, group)">
                            <p-accordion-header>
                                <span class="flex flex-wrap items-center gap-2">
                                    <span>Version {{ note.version }}</span>
                                    <span
                                        class="text-sm font-normal text-[var(--p-text-muted-color)]"
                                    >
                                        {{ note.date }}
                                    </span>
                                </span>
                            </p-accordion-header>
                            <p-accordion-content>
                                <ul class="list-disc pl-5">
                                    @for (change of note.changes; track $index) {
                                        <li>{{ change }}</li>
                                    }
                                </ul>
                            </p-accordion-content>
                        </p-accordion-panel>
                    }
                </p-accordion>
            </section>
        }
    </div>
</p-dialog>

<p-contextmenu
    #favoriteContextMenu
    [model]="favoriteContextMenuItems"
    class="absolute"
    appendTo="body"
>
    <ng-template #item let-item>
        @if (item.palette) {
            <div class="p-2">
                <div class="mb-2 font-medium">Choose background color</div>
                <div class="grid grid-cols-5 gap-2">
                    @for (color of favoriteColors; track color) {
                        <button
                            type="button"
                            class="h-6 w-6 cursor-pointer rounded-full border border-surface-400 transition-colors duration-150 hover:border-2 hover:border-[var(--p-primary-color)]"
                            [style.background-color]="color"
                            [attr.aria-label]="'Set favorite background color to ' + color"
                            (click)="selectFavoriteColor(color); $event.stopPropagation()"
                        ></button>
                    }
                </div>
            </div>
        } @else {
            <a class="p-contextmenu-item-link">
                <span class="p-contextmenu-item-icon" [ngClass]="item.icon"></span>
                <span class="p-contextmenu-item-label">{{ item.label }}</span>
            </a>
        }
    </ng-template>
</p-contextmenu>

<p-tieredmenu
    #favoriteMenu
    [model]="favoriteMenuItems"
    [popup]="true"
    class="absolute"
    appendTo="body"
/>
